module.exports = __webpack_public_path__ + "static/media/twitter.13b09900.svg";